import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

const navLinks = [
  { to: '/', label: '首页' },
  { to: '/category', label: '分类浏览' },
  { to: '/about', label: '关于我们' },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 60);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
  }, [location]);

  return (
    <nav
      className={`fixed top-0 left-0 w-full z-50 transition-all duration-300 ${
        scrolled
          ? 'bg-background-50/95 backdrop-blur-md border-b border-background-200/70'
          : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between h-16">
          <Link to="/" className="flex items-center gap-2 whitespace-nowrap cursor-pointer">
            <div className="w-8 h-8 flex items-center justify-center bg-primary-500 rounded-lg">
              <i className="ri-book-open-line text-background-50 text-lg"></i>
            </div>
            <span className="font-heading font-bold text-lg text-foreground-950">
              JM漫画导航
            </span>
          </Link>

          <div className="hidden md:flex items-center gap-8">
            {navLinks.map((link) => (
              <Link
                key={link.to}
                to={link.to}
                className={`text-sm font-medium whitespace-nowrap cursor-pointer transition-colors duration-200 ${
                  location.pathname === link.to
                    ? 'text-primary-600'
                    : 'text-foreground-700 hover:text-primary-500'
                }`}
              >
                {link.label}
              </Link>
            ))}
          </div>

          <div className="hidden md:flex items-center gap-3">
            <a
              href="https://jmcomic-zzz.one"
              target="_blank"
              rel="nofollow noopener noreferrer"
              className="inline-flex items-center gap-1.5 px-4 py-2 bg-primary-500 text-background-50 text-sm font-medium rounded-md hover:bg-primary-600 transition-colors duration-200 whitespace-nowrap cursor-pointer"
            >
              <i className="ri-external-link-line"></i>
              进入JM漫画
            </a>
          </div>

          <button
            onClick={() => setMobileOpen(!mobileOpen)}
            className="md:hidden w-10 h-10 flex items-center justify-center text-foreground-700 cursor-pointer"
            aria-label="切换菜单"
          >
            <i className={`text-xl ${mobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>
      </div>

      {mobileOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200/70">
          <div className="px-4 py-3 flex flex-col gap-2">
            {navLinks.map((link) => (
              <Link
                key={link.to}
                to={link.to}
                className={`px-3 py-2.5 rounded-md text-sm font-medium whitespace-nowrap cursor-pointer transition-colors ${
                  location.pathname === link.to
                    ? 'bg-primary-100 text-primary-700'
                    : 'text-foreground-700 hover:bg-background-100'
                }`}
              >
                {link.label}
              </Link>
            ))}
            <a
              href="https://jmcomic-zzz.one"
              target="_blank"
              rel="nofollow noopener noreferrer"
              className="mt-2 flex items-center justify-center gap-1.5 px-4 py-2.5 bg-primary-500 text-background-50 text-sm font-medium rounded-md hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
            >
              <i className="ri-external-link-line"></i>
              进入JM漫画
            </a>
          </div>
        </div>
      )}
    </nav>
  );
}